'use strict'

/**
 *
 * @name: nnBaseCheckbox
 *
 */

import DirectiveTemplate from './nn-base-checkbox.directive.html'
import './nn-base-checkbox.directive.scss'

function NnBaseCheckboxDirective () {

  'ngInject'

  return {
    restrict: 'E',
    replace: true,
    transclude: true,
    scope: {
      ngModel: '=',
      ngChange: '&'
    },
    template: DirectiveTemplate,
    controller: nnBaseCheckboxDirectiveController
  }
}

function nnBaseCheckboxDirectiveController ($scope, $timeout) {

  'ngInject'

  /*
   *
   * @CONFIG
   *
   */



  /*
   *
   * @PUBLIC
   *
   */

  $scope.onChange = () => {
    $timeout(() => {

      $scope.ngChange();
    }, 300);
  }


  /*
   *
   * @PRIVATE
   *
   */



  /*
   *
   * @INIT
   *
   */

  // -- For debugging
  // $scope.$watch('ngModel', val => {
  //   console.log('🦄 nn-base-checkbox.directive.js val', val)
  // })

}

export default NnBaseCheckboxDirective



// WEBPACK FOOTER //
// ./app/components/nn-base-components/nn-base-checkbox/nn-base-checkbox.directive.js